var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getVideoUrl)?_c('button',[_c('a',{staticClass:"game-button",attrs:{"href":_vm.getVideoUrl,"target":"_blank"}},[_vm._v(" COMS: Kingdom of Sales ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }